import { createArray, propsToArray } from '../utilities/arrayHelper';

function initializeAnswers(question, answers, { skipFreeText }) {
  switch (question.type) {
    case 'OneOf':
    case 'MultipleChoice':
      question.options.forEach((option) => {
        answers[`${question.question.uuid}.${option.uuid}`] = 0; // eslint-disable-line no-param-reassign
      });
      break;
    case 'ArbitraryString':
      if (!skipFreeText) {
        // eslint-disable-next-line no-param-reassign
        answers.freeText = { [question.question.uuid]: {} };
      }
      break;
    case 'IntegerPercentage':
      break;
    default:
      throw new Error(`Initialization of question type: ${question.type} for scorecard not supported: ${JSON.stringify(question)}`);
  }
}

export default class Scorecard {
  constructor(surveyPayload, params = {}) {
    this.sections = surveyPayload.sections;
    this.numSections = surveyPayload.sections.length;
    this.answersPerSample = surveyPayload.sections
      .reduce((total, section) => total + section.questions.length, 0);

    this.numCasesInSection = surveyPayload.sections.map((section) => section.numCases);

    this.accumulation = this.sections.map((section) => createArray(section.numCases)
      .map(() => {
        const answers = {};
        section.questions.forEach((question) => initializeAnswers(question, answers, params));
        return answers;
      }));

    this.numQuestions = createArray(this.numSections)
      .map((_, idx) => surveyPayload.sections[idx].questions.length);
  }

  accumulate(sampleIdx, sectionIdx, uuid) {
    if (sectionIdx !== undefined && uuid !== undefined) {
      // eslint-disable-next-line no-plusplus
      ++this.accumulation[sectionIdx][sampleIdx][uuid];
    } else {
      throw Error(`Could not accumulate item: ${sampleIdx}, ${sectionIdx}, ${uuid}`);
    }

    return this;
  }

  accumulateFreeText(sampleIdx, sectionId, questionUuid, freeTextAnswer) {
    if (!this.accumulation[sectionId][sampleIdx].freeText[questionUuid]) {
      this.accumulation[sectionId][sampleIdx].freeText[questionUuid] = {};
    }
    if (!this.accumulation[sectionId][sampleIdx].freeText[questionUuid][freeTextAnswer]) {
      this.accumulation[sectionId][sampleIdx].freeText[questionUuid][freeTextAnswer] = 1;
    } else {
      // eslint-disable-next-line no-plusplus
      ++this.accumulation[sectionId][sampleIdx].freeText[questionUuid][freeTextAnswer];
    }
  }

  setScore(sectionIdx, sampleIdx, uuid, score) {
    this.accumulation[sectionIdx][sampleIdx][uuid] = score;
  }

  getOccurrences(sampleIdx, sectionIdx, uuid) {
    return this.accumulation[sectionIdx][sampleIdx][uuid];
  }

  getTotalAnswers() {
    return this.answersPerSample * this.numSamples;
  }

  getNumSections() {
    return this.numSections;
  }

  getNumCasesInSection(sectionIdx) {
    return this.numCasesInSection[sectionIdx];
  }

  getNumCases() {
    return this.sections.map((section) => section.numCases)
      .reduce((acc, cur) => acc + cur, 0);
  }

  getNumQuestions(sectionIdx) {
    return this.numQuestions[sectionIdx];
  }

  json() {
    return this.accumulation;
  }

  getScoreSum(sectionId) {
    return propsToArray(this.accumulation[sectionId]).map(
      (column) => Object.keys(column).reduce((acc, cur) => acc + column[cur], 0),
    );
  }

  getSampleSums() {
    return createArray(this.getNumSections()).map((_, sectionId) => this.getScoreSum(sectionId));
  }
}
